import { ModeratorResponse } from "../../types/api/moderators";
import { UserRole } from "../../types/common/permissions";
import { PERMISSIONS_CONFIG } from "./config";

export const isAllowAction = (
  profile: ModeratorResponse | null,
  action: keyof typeof PERMISSIONS_CONFIG
) => {
  if (!profile) return false;
  if (profile.role === UserRole.USER) return false;

  // Пропустить проверку permissions для админов и супер админов
  if (profile.role === UserRole.ADMIN || profile.role === UserRole.SUPERADMIN) {
    const config = getPermissionConfig(action);
    return config.roles.some((role) => role === profile.role);
  }

  // Для модераторов проверять и роли и permissions
  const config = getPermissionConfig(action);
  const hasRole = config.roles.some((role) => role === profile.role);
  if (!hasRole) return false;

  if (config.permissions.length === 0 || !profile.permissions) return false;

  return config.permissions.every((permission) =>
    Boolean(profile.permissions![permission])
  );
};

export function getPermissionConfig(action: keyof typeof PERMISSIONS_CONFIG) {
  return PERMISSIONS_CONFIG[action];
}

export function getRolesForAction(action: keyof typeof PERMISSIONS_CONFIG) {
  return PERMISSIONS_CONFIG[action].roles;
}

export function getPermissionsForAction(
  action: keyof typeof PERMISSIONS_CONFIG
) {
  return PERMISSIONS_CONFIG[action].permissions;
}
